import type { Stripe } from '@stripe/stripe-js'
import { updateStripeOffSessionCardByRegionAndPurposeId } from 'api/payment'
import config from 'constants/config'

interface UpdateLuxPlusPrimaryCardInput {
  confirmWithSetup?: boolean
  currencyCode: string
  paymentMethodId: string
  purposeId: string
  regionCode: string
  stripe: Stripe
}

async function updateLuxPlusPrimaryCard(input: UpdateLuxPlusPrimaryCardInput): Promise<void> {
  const {
    confirmWithSetup,
    currencyCode,
    paymentMethodId,
    purposeId,
    regionCode,
    stripe,
  } = input

  const { clientSecret } = await updateStripeOffSessionCardByRegionAndPurposeId(regionCode, purposeId, {
    currency: currencyCode,
    brand: config.BRAND,
    paymentMethodType: 'card',
    metadata: {
      paymentMethodId,
      purpose: 'lux_plus',
    },
  })

  const setupResult = confirmWithSetup ? await stripe.confirmSetup({
    clientSecret,
    redirect: 'if_required',
  }) : await stripe.confirmCardSetup(clientSecret)

  if (setupResult.error) {
    throw new Error(setupResult.error.message)
  }
}

export default updateLuxPlusPrimaryCard
